import dayjs from "dayjs";
import React, { useEffect } from "react";
import { createContext, useContext, useState } from "react";

// Create Context
const MerchantContext = createContext();

// Provider Component
export const MerchantProvider = ({ children }) => {
  const [searchFieldsIncome, setSearchFieldsIncome] = useState({});
  const [searchFieldsInvoice, setSearchFieldsInvoice] = useState({
    status: "PAID",
    createdAt: [dayjs(), dayjs()],
  });
  const [showFilter, setShowFilter] = useState(true);
  const [permissions, setPermissions] = useState([]);
  useEffect(() => {
    fetchStorage();
  }, []);
  const fetchStorage = () => {
    const raw =
      sessionStorage.getItem("merchantData") ||
      localStorage.getItem("merchantData") ||
      "{}";
    const merchantData = JSON.parse(raw);
    if (merchantData && merchantData.permissions) {
      setPermissions(merchantData.permissions.map((e) => e.id));
    }
  };
  return (
    <MerchantContext.Provider
      value={{
        searchFieldsIncome,
        setSearchFieldsIncome,
        searchFieldsInvoice,
        setSearchFieldsInvoice,
        showFilter,
        setPermissions,
        permissions,
        setShowFilter,
      }}
    >
      {children}
    </MerchantContext.Provider>
  );
};

// Custom Hook
export const useMerchant = () => useContext(MerchantContext);
